import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapFieldDataTypeFilter = (item, index) => {
  return {
    index,
    key: uuidv4(),
    id: item?.data_type_id,
    name: item?.data_type_name,
    description: item?.data_type_description,
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
  }
}

export const getDataTypeFilterListApi = () => {
  const config = {
    method: 'get',
    url: '/api/v1/filters/data_type',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldDataTypeFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
